export default "__VITE_ASSET__C1c9T6oJ__"